'use client'

import { getCookie } from 'cookies-next/client'
import type { PropsWithChildren } from 'react'
import type { User } from '@/src/services/user'
import { sessionIdAtom, userAtom } from '@/src/stores/user/atoms'
import {
  loadSettings,
  userSettingsAtom,
} from '@/src/stores/user-settings/atoms'
import { HydrateAtoms } from './atom-hydrate'

interface HydrateUserProps extends PropsWithChildren {
  user: User
}

export function HydrateUser({ user, children }: HydrateUserProps) {
  const userSettings = loadSettings()

  return (
    <HydrateAtoms
      initialValues={[
        [userSettingsAtom, userSettings],
        [sessionIdAtom, getCookie('session-id')],
        [userAtom, user],
      ]}
    >
      {children}
    </HydrateAtoms>
  )
}
